import React, { useCallback, useContext, useEffect, useState } from 'react';
import './BookAppointment.css';
import dayjs from 'dayjs';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import { useHistory } from 'react-router';
import CalendarAppointment from './Calendar';
import DateSelector from './DateSelector';
import AgentDropdown from './AgentDropdown';
import { CircularProgress } from '@material-ui/core';

function BookAppointment() {
	const { firebase } = useContext(FirebaseContext);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [appointmentDate, setAppointmentDate] = useState(new Date());
	const [showDropdown, setShowDropdown] = useState(false);
	const [agentSelected, setAgentSelected] = useState();
	const [agentIdSelected, setAgentIdSelected] = useState();
	const [bookedTimeList, setBookedTimeList] = useState([]);
	const [clickedTime, setClickedTime] = useState(false);
	const [selectTime, setSelectTime] = useState();

	const handleConfirm = useCallback(async (e) => {
		try {
			var currentUserId = firebase.auth().currentUser.uid;
			// setClickedTime(false);

			console.log('currentUserId ' + currentUserId);
			var currentUserObj;
			var time = e.currentTarget.dataset.time;
			var appointmentPost;
			var users;
			setLoading(true);
			await firebase
				.database()
				.ref('/users/' + currentUserId)
				.once('value', function (snapshot) {
					var email = snapshot.val()?.email;
					var fullName = snapshot.val()?.fullName;
					var phoneNumber = snapshot.val()?.phoneNumber;
					currentUserObj = {
						email: email,
						fullName: fullName,
						phoneNumber: phoneNumber,
					};

					users = {
						'0': currentUserObj,
					};

					console.log('This is the currentUser : ' + time);

					appointmentPost = firebase
						.database()
						.ref('/client_appointments/' + PROJECT_CODE.projectCode)
						.push();

					var unixTime = dayjs(time);

					console.log('unixTime ' + '' + unixTime);
					console.log('appointmentPost ' + appointmentPost.key);
					console.log('fullName ' + JSON.stringify(currentUserObj));
					appointmentPost.update({
						appointmentID: appointmentPost.key,
						appointmentName: `Appointment with ${currentUserObj.fullName}`,
						assignedTo: 'Adhoc',
						createrID: agentIdSelected,
						sentRemind: false,
						started: false,
						timeOfAppointment: parseInt(time),
						users: {
							'0': {
								email: '' + currentUserObj.email,
								fullName: '' + currentUserObj.fullName,
								phoneNumber: '' + currentUserObj.phoneNumber,
							},
						},
					});
				});
			setLoading(false);
			setClickedTime(false);
		} catch (error) {
			console.error(error);
		}
	});

	return (
		<>
			{showDropdown === true && (
				<div
					className='dropdown_backdrop'
					onClick={() => setShowDropdown(false)}
				></div>
			)}

			<div className='book-appointment-page'>
				{loading && (
					<div className='loading_layout_book_appointment'>
						<CircularProgress
							style={{ position: 'absolute', left: '40%', top: '30%' }}
						/>
					</div>
				)}
				<h2 id='client-title'>Book Appointment</h2>
				{/* <button onClick={() => setClickedTime(false)}>Reset</button> */}
				<AgentDropdown
					showDropdown={showDropdown}
					setShowDropdown={setShowDropdown}
					agentSelected={agentSelected}
					setAgentSelected={setAgentSelected}
					setAgentIdSelected={setAgentIdSelected}
				/>
				{agentSelected && (
					<div className='appointment_selector_wrapper'>
						<CalendarAppointment
							appointmentDate={appointmentDate}
							setAppointmentDate={setAppointmentDate}
							agentSelected={agentSelected}
							agentIdSelected={agentIdSelected}
							setBookedTimeList={setBookedTimeList}
						/>
						<DateSelector
							appointmentDate={appointmentDate}
							setAgentIdSelected={setAgentIdSelected}
							bookedTimeList={bookedTimeList}
							setSelectTime={setSelectTime}
							selectTime={selectTime}
							handleConfirm={handleConfirm}
							setClickedTime={setClickedTime}
							clickedTime={clickedTime}
						/>
					</div>
				)}
			</div>
		</>
	);
}

export default BookAppointment;
